import React, { useEffect, useState } from 'react';
import './App.css';
import Tmdb from './components/Tmdb/index'; 
import MovieRow from './components/MovieRow/index';
import FeaturedMovie from './components/FeaturedMovie/index'
import Header from './components/Header/index';

  export default () => {

    const [movieList, setMovieList] = useState([]);
    const [featuredData, setFeaturedData] = useState(null);
    const [blackHeader, setBlackHeader] = useState(false);

    useEffect(()=>{
      const loadAll = async () => {
        // Pegando a lista TOTAL
        let list = await Tmdb.getHomeList();
        setMovieList(list);
      
        //Pegando o Featured
        let originals = list.filter(i=>i.slug === 'originals');
        let randomChosen = Math.floor(Math.random() * (originals[0].items.results.length - 1));      
        let chosen = originals[0].items.results[randomChosen];
        let chosenInfo = await Tmdb.getMovieInfo(chosen.id,'tv');
        setFeaturedData(chosenInfo);
      }
      
      
      loadAll();
    }, []);

    useEffect(()=>{
      const scrollListener = () =>{
        if (window.scrollY > 10){
          setBlackHeader(true);
        } else{
          setBlackHeader(false);
        }
      }

      window.addEventListener('scroll', scrollListener);   
      return () => {
        window.removeEventListener('scroll', scrollListener);
      }

    }, []);

    return (
      <div className="page">

        <Header black={blackHeader} />

        {featuredData &&
          <FeaturedMovie item = {featuredData} />
        }

        <section className="lists">
          {movieList.map((item, key)=>(
              <MovieRow key={key} tittle={item.tittle} items={item.items} />
          ))}
        </section>

        <footer>
          Feito com <span role="img" aria-label="coração">💘</span> Por <a href="https://kain-prog.github.io/kain">Kain-Dev</a> <br/>
          Direitos de imagem para <strong>Netflix</strong> <br/>
          Dados pegos do site <strong>Themoviedb.org</strong>
        </footer>


        {movieList.length <= 0 &&
            <div className="loading">
              <img src="https://steamcdn-a.akamaihd.net/steamcommunity/public/images/clans/26347107/71840a9ec5d9ede062150fdcab8bde009dd81f94.gif" alt="Carregando" />
            </div>
        }


      </div>
    );
  }